import React from "react";
import { useTranslation } from "react-i18next";

function TabAtom(props) {
	const { selectedTab, tabs, onTabClick } = props;
	const { t } = useTranslation();

	return (
		<ol className="d-flex operation-container">
			<li>
				{t("orders")}
			</li>
			{tabs.map((tab, index) => {
				return (
					<li key={index}>
						<div
							role="button"
							className={
								selectedTab === tab.key
									? "operation-btn active-tab"
									: "operation-btn"
							}
							onClick={() => onTabClick(tab.key)}
						>
							{tab.label}
						</div>
					</li>
				);
			})}
		</ol>
	);
}

export default TabAtom;
